import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('loan/page', data)
